import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VegaLite from 'react-vega-lite';
import * as Icon from 'react-feather';
import {Handler} from 'vega-tooltip';

import './css/vegaCharts.css';

class VegaChart extends Component {
    _handleHover(){
        //console.log(args);
    }
    
    render(){
        const classes = `vega-chart-wrapper ${this.props.className || ""}`;
        const { spec, data } = this.props;
        const hasData = data.values.length > 0;

        return(
            <div className={classes}>
                {!hasData &&
                    <div className="no-data-overlay text-info">
                        <label>
                            <Icon.Info /><br />
                            No data to display.<br />
                            <small>Please select a different time range.</small>
                        </label>
                    </div>
                }
                <VegaLite spec={spec} data={data} tooltip={new Handler().call} />
            </div>
        );
    }
    
}

VegaChart.propTypes = {
    data: PropTypes.object.isRequired,
    spec: PropTypes.object.isRequired,
    handleHover: PropTypes.func,
    className: PropTypes.string,
};

export default VegaChart;